import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';


const Footer = ({ intl }) => {
    const currentYear = new Date().getFullYear();

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className="footerTop">

                <div>
                    <List className="footerList">
                        <div role="listitem" className="item title">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Kontakt"
                                    defaultMessage="Kontakt"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item footerName">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Name"
                                    defaultMessage="probon Emmental und Entlebuch"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Geschäftsstelle"
                                    defaultMessage="Geschäftsstelle Daniel Wenger"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-phone-line"></i>
                            <a className="item" href="tel:+41 79 737 79 68">
                                <FormattedMessage
                                    id='Footer-Telefon'
                                    defaultMessage="+41 79 737 79 68"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-mail-line"></i>
                            <a className="item" href="mailto:sekretariat@probon-emme.ch">
                                <FormattedMessage
                                    id='Footer-Email'
                                    defaultMessage="sekretariat@probon-emme.ch"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Postfach"
                                    defaultMessage="Postfach"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Adress"
                                    defaultMessage="Dorfstrasse 5, Eingang B (1. Stock links)"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id='Footer-Plz-Ort'
                                    defaultMessage="3550, Langnau i.E."
                                />
                            </p>
                        </div>
                    </List>
                </div>

                <div>
                    <List className="footerList">
                        <div role="listitem" className="item title">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Link-Title"
                                    defaultMessage="Links"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item"  href="https://www.probon.ch/" target="_blank">
                                <FormattedMessage
                                    id='Footer-Link-Probon-Schweiz'
                                    defaultMessage="Probon Schweiz"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item"  href="https://www.biosphaere.ch/" target="_blank">
                                <FormattedMessage
                                    id='Footer-Link-Biosphäre'
                                    defaultMessage="Biosphäre"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item"  href="https://www.emmental.ch/" target="_blank">
                                <FormattedMessage
                                    id='Footer-Link-Emmental'
                                    defaultMessage="Emmental"
                                />
                            </a>
                        </div>
                    </List>
                </div>
            </div>
            <hr />
            <div className='footerBottom'>
                <div>
                    <List className="footerList">
                        <div role="listitem" className="item">
                            <a className="item" href="./impressum">
                                <FormattedMessage
                                    id='Footer-Imprint'
                                    defaultMessage="Impressum"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./datenschutz">
                                <FormattedMessage
                                    id='Footer-Privacy'
                                    defaultMessage="Datenschutzerklärung"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-copyright-line"></i>
                            {currentYear}&nbsp;
                            <FormattedMessage
                                id='Footer-Copyright'
                                defaultMessage="probon Emmental und Entlebuch"
                            />
                        </div>
                    </List>
                </div>
            </div>
        </Segment>
    );
};

export default injectIntl(Footer);